import xss from "xss";

export default {

  isSignedIn: false,
  isUserSignedIn: false,
  _kundenId: null,
  _user: null,

  get user() {
    return { ...(this._user || {}) };
  },

  get userId() {
    if (!this._user) return null;
    return this._user.id;
  },

  set userId(value) {
    if (!this._user) this._user = {};
    this._user.id = !isNaN(value) ? Number(value) : null;
  },

  get kundenId() {
    return this._kundenId;
  },

  set kundenId(value) {
    this._kundenId = !isNaN(value) ? Number(value) : null;
  },


  signIn(kundenId) {
    this.isSignedIn = true;
    this.kundenId = kundenId;
  },

  beraterLogon(user) {
    if (!user || !user.userId || !String(user.userId).match(/^[a-z0-9]+$/i)) return;
    this._user = {
      id: Number(user.userId),
      name: xss(user.name),
      telefon: xss(user.telefon),
      platz: xss(user.platz)
    };
    this.isUserSignedIn = true;
  }
};
